import { Fragment } from "react";
import Button from "../Button/Button";
import styles from "./Filters.module.scss";
import { Filter, FilterConfiguration } from "./types";
import FilterPreview from "./FilterPreview";

function Filters({
  filters,
  setIsAddingFilter,
  setIsEditingFilter,
  deleteFilter,
}: {
  filters: Filter[];
  setIsAddingFilter: () => void;
  setIsEditingFilter: (filter: FilterConfiguration, index: number) => void;
  deleteFilter: (index: number) => void;
}) {
  return (
    <div className={styles.container}>
      {filters.map((filter, index) => (
        <Fragment key={index}>
          <FilterPreview
            filter={filter}
            onDelete={() => deleteFilter(index)}
            onEdit={(filterOptions) => setIsEditingFilter(filterOptions, index)}
          />
          {index !== filters.length - 1 && (
            <span className={styles.andSeparator}>and</span>
          )}
        </Fragment>
      ))}
      <Button
        className={styles.addFilterButton}
        variant="outline"
        size="xsmall"
        onClick={() => setIsAddingFilter()}
      >
        AND
      </Button>
    </div>
  );
}

export default Filters;
